import React, {Component} from 'react';
import PropTypes from 'prop-types';

import DefaultLayout from './DefaultLayout.jsx';

export default class PageLayout extends Component {
  static propTypes = {
    helmet: PropTypes.object,
  };

  static defaultProps = {
    helmet: {title: '', description: ''},
  };

  render() {
    const { helmet } = this.props;

    return (
      <DefaultLayout showSidebarMenu={false} helmet={helmet} className="bg-gray-50">
        <div className="container">
          <div className="row">
            <div className="col-xxl-8 mx-auto bg-white bd-gray-200 p-5 my-5">
              {this.props.children}
            </div>
          </div>
        </div>
      </DefaultLayout>
    );
  }
}